import React from "react";
import { CurrencyInput } from "./CurrencyInput";

export const NumericMask = ({ className, onChange, value, customRef, ...props }) => {
  return (
    <CurrencyInput
      {...props}
      className={className}
      customRef={customRef}
      currency="BRL"
      value={value}
      onChange={onChange}
    />
  );
};

NumericMask.displayName = "NumericMask";
